

<div id="desktop">
  <div class="sign-area">
    <canvas #signCanvasDesktop 
    [style.filter]="darkmode.isDarkModeValue ? 'invert(1)' : ''"
    (touchstart)="handleStart($event)"
    (touchmove)="handleMove($event)"
    (mousedown)="handleStart($event)"
    (mousemove)="handleMove($event)"
    (mousedown)="isMouseDown = true"
    (mouseup)="isMouseDown = false"
    ></canvas>
    <div class="sign-line">
      <div class="line"></div>
      <h2>Unterschrift</h2>
    </div>
  </div>

  <div class="toolbar">
    <div class="sign-bttn" (click)="clearCanvas()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M135.2 17.69C140.6 6.848 151.7 0 163.8 0H284.2C296.3 0 307.4 6.848 312.8 17.69L320 32H416C433.7 32 448 46.33 448 64C448 81.67 433.7 96 416 96H32C14.33 96 0 81.67 0 64C0 46.33 14.33 32 32 32H128L135.2 17.69zM394.8 466.1C393.2 492.3 372.3 512 346.9 512H101.1C75.75 512 54.77 492.3 53.19 466.1L31.1 128H416L394.8 466.1z"/></svg>
    </div>
    <div class="sign-bttn" (click)="complete()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"/></svg>
    </div>
  </div>

</div>